const exp = [
  {
    id: 0,
    title: "Facility.Step.GeneralData",
    route: `/facilities/{id.documentId}/{id.siteId}/generalData`,
    completed: false,
    disabled: false,
    error: false,
    visible: () => {
      return true;
    }
  },
  {
    id: 1,
    title: "Facility.Step.Sublimits",
    route: `/facilities/{id.documentId}/{id.siteId}/sublimits`,
    completed: false,
    disabled: false,
    error: false,
    visible: () => {
      return true;
    }
  },
  {
    id: 2,
    title: "Facility.Step.KpiIndicators",
    route: `/facilities/{id.documentId}/{id.siteId}/kpiIndicators`,
    completed: false,
    disabled: false,
    error: false,
    visible: () => {
      return true;
    }
  }
];

export default exp;
